
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark-900 py-20 lg:py-0">
      <div className="absolute inset-0 w-full h-full">
        <div className="absolute inset-0 bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900"></div>
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-red-900/5 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-20">
          
          {/* Foto Pessoal */}
          <div className="relative order-1 lg:order-2 flex-shrink-0 flex items-center justify-center">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-red-600/30 to-red-900/20 rounded-full blur-2xl"></div>
              <div className="relative w-64 h-64 sm:w-72 sm:h-72 lg:w-80 lg:h-80 rounded-full overflow-hidden border-4 border-red-600/50 shadow-2xl shadow-red-900/30">
                <img 
                  src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/424b4e2665ab367b605add57909a0d12.jpeg"
                  alt="Rafael Figueiredo Silva"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-verified-badge-fill text-2xl text-white"></i>
              </div>
            </div>
          </div>

          {/* Conteúdo */}
          <div className="order-2 lg:order-1 text-center lg:text-left flex-1 max-w-xl">
            <div className="inline-flex items-center bg-red-600/20 border border-red-600/30 rounded-full px-4 py-2 mb-6">
              <span className="w-2 h-2 bg-red-500 rounded-full mr-2 animate-pulse"></span>
              <span className="text-red-400 text-sm font-medium">Especialista em Inteligência Artificial</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
              RAFAEL<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">FIGUEIREDO</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-gray-400 mb-8 max-w-lg mx-auto lg:mx-0">
              Transformo negócios com soluções premium em <span className="text-red-400">Inteligência Artificial</span>, agentes personalizados e criação de sites inteligentes
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <button 
                onClick={() => scrollToSection('contato')}
                className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-8 py-4 rounded-full text-base font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center justify-center space-x-3 shadow-lg shadow-red-900/40 hover:shadow-xl hover:shadow-red-900/50 transform hover:-translate-y-1"
              >
                <i className="ri-chat-1-line text-xl"></i>
                <span>FALE COMIGO</span>
              </button>
              
              <button 
                onClick={() => scrollToSection('servicos')}
                className="w-full sm:w-auto bg-transparent border-2 border-gray-600 hover:border-red-500 hover:text-red-400 text-gray-300 px-8 py-4 rounded-full text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                MEUS SERVIÇOS
              </button>
            </div>

            {/* Redes Sociais */}
            <div className="flex items-center justify-center lg:justify-start gap-4 mt-8">
              <a 
                href="https://instagram.com/neuroagentsglobal" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-dark-700 hover:bg-gradient-to-br hover:from-pink-600 hover:to-red-600 border border-dark-600 hover:border-transparent rounded-full flex items-center justify-center transition-all cursor-pointer group"
              >
                <i className="ri-instagram-line text-xl text-gray-400 group-hover:text-white"></i>
              </a>
              <a 
                href="https://wa.me/5541992584018" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-dark-700 hover:bg-green-600 border border-dark-600 hover:border-transparent rounded-full flex items-center justify-center transition-all cursor-pointer group"
              >
                <i className="ri-whatsapp-line text-xl text-gray-400 group-hover:text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
